import { useEffect, useRef } from "react";
import { FiLoader } from "react-icons/fi";

export default function DeleteFeedPopup({ kind, busy, error, onClose, onConfirm }) {
  const ref = useRef(null);
  useEffect(() => {
    const dialog = ref.current;
    const focus = document.activeElement;
    dialog.showModal();
    return () => { dialog.close(); focus?.focus(); };
  }, []);
  return <dialog ref={ref} aria-label={`Delete ${kind}`} onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}
    className="m-auto w-[calc(100%-2rem)] max-w-sm rounded-lg border border-gray-200 bg-white p-6 text-gray-900 shadow-xl backdrop:bg-black/40">
    <h2 className="text-lg font-semibold">Delete {kind}?</h2>
    <p className="mt-3 text-sm text-gray-600">This {kind} will no longer be visible. This cannot be undone.</p>
    {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
    <div className="mt-6 flex justify-end gap-3">
      <button autoFocus disabled={busy} onClick={onClose} className="h-10 rounded-md border border-gray-300 px-4 text-sm">Keep {kind}</button>
      <button disabled={busy} onClick={onConfirm} aria-label={`Confirm delete ${kind}`} aria-busy={busy} className="flex h-10 min-w-20 items-center justify-center rounded-md bg-red-700 px-4 text-sm font-semibold text-white disabled:cursor-not-allowed">{busy ? <FiLoader className="animate-spin" /> : "Delete"}</button>
    </div>
  </dialog>;
}
